import React, { useEffect } from 'react';

interface AdSlotProps {
  slot: string;
  format?: string;
}

export const AdSlot: React.FC<AdSlotProps> = ({ slot, format }) => {
  useEffect(() => {
    try {
      const w = window as any;
      (w.adsbygoogle = w.adsbygoogle || []).push({});
    } catch (e) {
      console.error(e);
    }
  }, []);

  const isBanner = format === 'banner';
  const w = isBanner ? '320px' : '300px';
  const h = isBanner ? '50px' : '250px';

  return (
    <div className="ad-slot-wrap" style={{ width: w, height: h }}>
      <ins
        className="adsbygoogle"
        style={{ display: 'block', width: w, height: h }}
        data-ad-client="ca-pub-1278871437559102"
        data-ad-slot={slot}
      />
    </div>
  );
};
